import { render, staticRenderFns } from "./template.vue?vue&type=template&id=53d3ad75&scoped=true&"
import script from "./template.vue?vue&type=script&lang=ts&"
export * from "./template.vue?vue&type=script&lang=ts&"
import style0 from "./template.vue?vue&type=style&index=0&id=53d3ad75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3ad75",
  null
  
)

export default component.exports